// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';

// Components
// import Component from '~/components/componentName';

/**********
 ** Component: MyTeamChip
 ** @type: functional stateless component
 ** @description: My Team Members Chip
 **********/
const MyTeamChip = props => {
	let chipLabel;

	if (props.isUser) {
		if (props.isCaptain) {
			chipLabel = 'Captain';
			return <Chip isCaptain={props.isCaptain}>{chipLabel}</Chip>;
		} else {
			chipLabel = props.customLabel ? props.customLabel : 'Member';
			return <TeamMemberChip title="Member of this Team">{chipLabel}</TeamMemberChip>;
		}
	} else {
		if (props.isRequired) {
			chipLabel = 'Required';
			return <PlaceholderChip title="User is required">{chipLabel}</PlaceholderChip>;
		} else {
			return null;
		}
	}
};

const Chip = styled.span`
	margin: 0 auto;
	width: ${rem('62px')};
	height: ${rem('20px')};
	border-radius: ${rem('20px')} !important;
	line-height: ${rem('20px')};
	padding-left: ${rem('12px')};
	padding-right: ${rem('12px')};
	background-color: ${props => props.theme.primaryColor};
	color: ${props => props.theme.white};
	text-align: center;
	border: 0;
	font-size: ${rem('12px')};
	cursor: pointer;
	transform: scale(1);
	transition: all 200ms ease-in-out;

	&:hover {
		transform: scale(1.25);
	}
`;

const TeamMemberChip = styled(Chip)`
	background-color: hsl(240, 11%, 20%);
`;

// const RemoveUserChip = Chip.extend`
//   background-color: hsl(12, 94%, 55%);
// `;

const PlaceholderChip = styled(Chip)`
	background-color: hsl(210, 12%, 74%);
`;

MyTeamChip.defaultProps = {
	customLabel: null,
	isCaptain: false,
	isUser: true,
	isRequired: false,
};

MyTeamChip.propTypes = {
	customLabel: PropTypes.string,
	isCaptain: PropTypes.bool,
	isUser: PropTypes.bool,
	onClick: PropTypes.func,
	isRequired: PropTypes.bool,
};

export default MyTeamChip;



// WEBPACK FOOTER //
// ./src/pages/profile/my-team/my-team-chip.jsx